import Vue from 'vue';
import 'primeicons/primeicons.css';

import PrimeVue from 'primevue/config';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import Slider from 'primevue/slider';
import Tooltip from 'primevue/tooltip';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';

Vue.use(PrimeVue, {
    locales: {
        en: {
            firstDayOfWeek: 1,
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            monthNames: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear',
            dateFormat: 'mm/dd/yy',
            weekHeader: 'Wk',
        },
        hu: {
            firstDayOfWeek: 1,
            dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
            dayNamesShort: ['Vas', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo'],
            dayNamesMin: ['Vas', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo'],
            monthNames: [
                'Január',
                'Február',
                'Március',
                'Április',
                'Május',
                'Június',
                'Július',
                'Augusztus',
                'Szeptember',
                'Október',
                'November',
                'December',
            ],
            monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
            today: 'Ma',
            clear: 'Törlés',
            dateFormat: 'nn/hh/éééé',
            weekHeader: 'Hét',
        },
    },
});

Vue.component('Dropdown', Dropdown);
Vue.component('Slider', Slider);
Vue.directive('tooltip', Tooltip);

// The actually used components are not the ones below, but the ones in global-component.js
Vue.component('OrgCalendar', Calendar);
Vue.component('OrgCheckbox', Checkbox);
Vue.component('OrgRadioButton', RadioButton);
Vue.component('OrgAccordion', Accordion);
Vue.component('OrgAccordionTab', AccordionTab);
